export default __webpack_public_path__ + "static/lavacao-dc63387acc508ef7a4d5e79f1e9019a9.jpg";